module.exports = __webpack_public_path__ + "img/icon-next-disable.ab3aa10d.png";